import React, {Fragment, useState} from "react";
import {useFieldArray} from "react-hook-form";
import OrderProduct from "./product/OrderProduct";
import {confirmAlert} from "../../../Components/Alerts/BasicAlert";
import axios from "axios";
import {useParams} from "react-router-dom";

export default function ({register, watch, setValue, errors, validateData, control, data, setData}) {
  const {fields, append, remove, update} = useFieldArray({
    control,
    name: "products",
    keyName: "index",
  });

  const [editingProductInfo, setEditingProductInfo] = useState({
    index: null,
    new: false,
    oldInfo: {}
  })

  const removeProduct = (index) => {
    confirmAlert('You want to remove this product?', () => {
      remove(index);
      setEditingProductInfo({
        index: null,
        new: false,
      });
      recalculateOrderPrice()
    }, ["No", "Yes"])
  };

  const cancelEdit = async () => {
    if (editingProductInfo.new === false) {
      update(editingProductInfo.index, editingProductInfo.oldInfo)
    } else {
      remove(editingProductInfo.index)
    }

    setEditingProductInfo({
      index: null,
      new: false,
      oldInfo: {}
    })

    let isValid = await validateData();
  }

  const updateProduct = async () => {
    let isValid = await validateData();

    if (isValid) {
      update(editingProductInfo.index, {...editingProductInfo.oldInfo, ...watch(`products.${editingProductInfo.index}`), is_modified: true})
      setEditingProductInfo({
        index: null,
        new: false,
        oldInfo: {}
      })
      recalculateOrderPrice()
    }
  }

  const recalculateOrderPrice = () => {
    let orderProducts = [...watch('products')]

    let totalOrderPrice = orderProducts?.reduce((total, product) => {
      // Calculate the sum of quantities for each product's addresses
      const totalQuantity = product.addresses?.reduce((sum, address) => sum + address.quantity, 0);
      // Multiply the dealing price by the total quantity of addresses
      return total + (product.product_price * totalQuantity);
    }, 0);

    setData({...data, order: {...data.order, price: totalOrderPrice, total_discounted_price: totalOrderPrice}});
  }

  return (
    <>
      <div className="col-12 pt-5">
        <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
          <div className="card-header d-flex justify-content-between align-items-center">
            <div className="card-title">
              <h2>Products</h2>
            </div>
            {
              editingProductInfo?.index === null && (
                <button
                  className="btn btn-primary btn-sm "
                  onClick={() => {
                    setEditingProductInfo({
                      index: fields.length,
                      new: true,
                      oldInfo: {}
                    })
                    append({
                      id: null,
                      product_price: 0,
                      dealing_price: 0,
                      addresses: [],
                      comment: null,
                      status: null,
                      is_modified: true
                    });
                  }}
                >
                  Add Product
                </button>
              )
            }

          </div>
          <div className="card-body pt-0">
            {
              editingProductInfo?.index !==null && (
                <OrderProduct
                  data={data}
                  setData={setData}
                  watch={watch}
                  setValue={setValue}
                  errors={errors}
                  control={control}
                  register={register}
                  index={editingProductInfo?.index}
                  update={update}
                  handleSave={updateProduct}
                  close={() => {
                    cancelEdit();
                  }}
                />
              )
            }
            <div className="table-responsive">
              <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0" style={{pointerEvents: editingProductInfo.index !== null ? 'none' : 'inherit'}}>
                <thead>
                <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0 border-bottom-2 border-dark">
                  <th className="min-w-175px">Id</th>
                  <th className="min-w-175px">Name</th>
                  <th className="min-w-175px">Shop Name</th>
                  <th className="min-w-100px">SKU</th>
                  <th className="min-w-70px">Qty</th>
                  <th className="min-w-70px">Status</th>
                  <th className="min-w-100px">Unit Price</th>
                  <th className="min-w-150px">Dealing Price</th>
                  <th className="min-w-100px">Total</th>
                  <th className="min-w-100px">Edit</th>
                  <th className="min-w-100px">Delete</th>
                </tr>
                </thead>
                <tbody className="fw-bold text-gray-600">
                {fields.map((product, index) => {
                  return product.id ? <Fragment key={product.index}>
                    <tr>
                      <td>
                        {product.id}
                      </td>
                      {/*<td className="text-end">*/}
                      {/*  <div className="d-flex align-items-center">*/}
                      {/*    {product.image && <span*/}
                      {/*      className="symbol-label"*/}
                      {/*      style={{*/}
                      {/*        backgroundImage:*/}
                      {/*          `url(${product.image})`*/}
                      {/*      }}*/}
                      {/*    />}*/}
                      {/*    <div className="ms-5">*/}
                      {/*      {product.name}*/}
                      {/*    </div>*/}
                      {/*  </div>*/}
                      {/*</td>*/}
                      <td>{product.name}</td>
                      <td>{product.shop_name}</td>
                      <td>{product.sku}</td>
                      <td>
                        {
                          product?.addresses?.reduce((sum, address) => {
                            return sum + parseInt(address.quantity);
                          }, 0)
                        }
                      </td>
                      <td>{data?.orderProductStatuses?.find(item => item.id === product.status)?.name}</td>
                      <td>{product.product_price}</td>
                      <td>{product.dealing_price}</td>
                      <td>
                        {
                          product?.addresses?.reduce((sum, address) => {
                            return sum + parseInt(address.quantity);
                          }, 0) * product.product_price
                        }
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            setEditingProductInfo({
                              index: index,
                              new: false,
                              oldInfo: product
                            })}
                        >
                          Edit
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => {
                            removeProduct(index)
                          }}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                    {product.addresses.length && (
                      <tr className="border-bottom-2 border-dark">
                        <td colSpan={3}>
                          {product.addresses.map((address, key) => {
                            return <div key={key} className="row pt-4 pb-4">
                              <div className="col">Address</div>
                              <div className="col">Quantity</div>
                              <div className="col">Delivery Code</div>
                              <div className="w-100"></div>
                              <div className="col fw-normal mt-2">
                                {data?.shopAddresses?.find(item => item.id === address.shop_address_id)?.address}
                              </div>
                              <div className="col fw-normal mt-2">{address.quantity}</div>
                              <div className="col fw-normal mt-2">{address.delivery_code}</div>
                            </div>
                          })}
                        </td>
                      </tr>
                    )}
                  </Fragment> : ""
                })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}